<template>
  <zm-alert
    v-if="showDownsellTip"
    :title="$t('billing.error.price_change_tip', [downsellPlanName])"
    type="warning"
    show-icon
    :closable="false"
    class="opc-cart__downsell-tip"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import { getEffectiveAmount } from '@/utils/downsell-price';

export default {
  name: 'DownsellTip',
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans']),
    
    showDownsellTip() {
      // Only show in edit mode
      if (!this.$context?.is?.edit) {
        return false;
      }

      // Check if any selected plan is using downsell pricing
      return this.getSelectedPlans.some(plan => this.isPlanUsingDownsellPrice(plan));
    },

    downsellPlanName() {
      // Find the first plan that is using downsell pricing
      const downsellPlan = this.getSelectedPlans.find(plan => this.isPlanUsingDownsellPrice(plan));
      
      if (!downsellPlan) {
        return '';
      }

      // Return the plan name based on plan type
      if (downsellPlan.type === planTypes.LARGE_MEETING) {
        return this.$t('billing.large_meeting.title');
      } else if (downsellPlan.type === planTypes.WEBINAR) {
        return this.$t('billing.webinar.title');
      }
      
      return '';
    }
  },
  
  methods: {
    isPlanUsingDownsellPrice(plan) {
      // Only LARGE_MEETING and WEBINAR support downsell
      if (![planTypes.LARGE_MEETING, planTypes.WEBINAR, planTypes.ZOOM_CUSTOM_AI_COMPANION].includes(plan.type)) {
        return false;
      }

      // Check if plan has downsell capability
      if (!plan.isDownsellAmountOverwrite || !plan.downsellAmount) {
        return false;
      }

      // Get current license from bought plans
      const boughtPlan = this.boughtPlans?.find(bp => 
        bp.plan_code === plan.plan_code || bp.type === plan.type
      );
      const currentLicense = boughtPlan?.cartInfo?.selected_number || 0;
      const newLicense = plan.cartInfo?.selected_number || 0;

      // Check if license is decreasing and effective amount is different from original amount
      if (newLicense < currentLicense && newLicense > 0) {
        const context = { currentLicense };
        const effectiveAmount = getEffectiveAmount(plan, context);
        return effectiveAmount !== plan.amount;
      }

      return false;
    }
  }
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-cart__downsell-tip {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 14px;
  
  @include media(mobile, tablet) {
    margin-top: 12px;
    margin-bottom: 6px;
  }
}
</style>
